import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Button, Modal, Badge, Spinner, EmptyState, PageHeader } from '../components/Common';
import { API_URL } from '../config';

const API = `${API_URL}/super-admin`;
const getToken = () => localStorage.getItem('bhamsa_sa_token');

const emptyForm = {
  name: '', email: '', password: '', shop_name: '',
  phone: '', whatsapp: '', address: '', city: '',
};

const SuperAdminAdmins = () => {
  const [admins,    setAdmins]    = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [search,    setSearch]    = useState('');
  const [showModal, setShowModal] = useState(false);
  const [form,      setForm]      = useState(emptyForm);
  const [saving,    setSaving]    = useState(false);
  const [editModal, setEditModal] = useState(false);
const [editForm, setEditForm] = useState({});
const [editId, setEditId] = useState(null);

  const load = async () => {
    try {
      const res = await axios.get(`${API}/admins`, {
        headers: { Authorization: `Bearer ${getToken()}` },
        params: { search },
      });
      setAdmins(res.data.admins);
    } catch { toast.error('Admins load nahi hue'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search]);

  const handleSave = async () => {
    if (!form.name || !form.email || !form.password || !form.shop_name) {
      toast.error('Saare required fields fill karo'); return;
    }
    setSaving(true);
    try {
      await axios.post(`${API}/admins`, form, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      toast.success('New admin ban gaya! ✅');
      setShowModal(false);
      setForm(emptyForm);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSaving(false); }
  };

  const openEdit = (a) => {
  setEditForm({
    name: a.name || '',
    shop_name: a.shop_name || '',
    phone: a.phone || '',
    whatsapp: a.whatsapp || '',
    email: a.email || '',
    address: a.address || '',
    city: a.city || '',
    password: '',
  });
  setEditId(a.id);
  setEditModal(true);
};

const handleUpdate = async () => {
  if (!editForm.name || !editForm.shop_name) {
    toast.error('Name aur Shop Name required hai');
    return;
  }
  setSaving(true);
  try {
    await axios.put(`${API}/admins/${editId}`, editForm, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    toast.success('Admin update ho gaya! ✅');
    setEditModal(false);
    load();
  } catch (err) {
    toast.error(err.response?.data?.message || 'Error aaya');
  } finally {
    setSaving(false);
  }
};

  const toggleStatus = async (id, currentStatus) => {
    try {
      await axios.put(`${API}/admins/${id}/toggle`, {}, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      toast.success(`Admin ${currentStatus ? 'Deactive' : 'Active'} ho gaya!`);
      load();
    } catch { toast.error('Status change nahi hua'); }
  };

  const f = (field, val) => setForm(p => ({ ...p, [field]: val }));

  return (
    <div className="page">
      <PageHeader
        title="👥 Admin Management"
        subtitle={`${admins.length} total admins`}
        actions={
          <Button onClick={() => { setForm(emptyForm); setShowModal(true); }}>
            + New Admin
          </Button>
        }
      />

      {/* Search */}
      <div className="search-wrap" style={{ marginBottom: 20, maxWidth: 360 }}>
        <span className="search-icon">🔍</span>
        <input
          className="form-input"
          placeholder="Name, email, shop search..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ paddingLeft: 34 }}
        />
      </div>

      {/* Table */}
      <div className="card">
        <div className="table-wrap">
          {loading ? <Spinner /> : admins.length === 0 ? (
            <EmptyState icon="👥" title="Koi admins nahi" message="'+ New Admin' se add karo" />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Shop Name</th><th>Admin Name</th><th>Email</th>
                  <th>Phone</th><th>Plan Status</th><th>Expiry</th>
                  <th>Status</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {admins.map(a => (
                  <tr key={a.id}>
                    <td><strong>{a.shop_name || '—'}</strong></td>
                    <td>{a.name}</td>
                    <td style={{ fontSize: 12, color: 'var(--text2)' }}>{a.email}</td>
                    <td>{a.phone || '—'}</td>
                    <td>
                      <Badge variant={
                        a.subscription_status === 'active' ? 'green' :
                        a.subscription_status === 'trial'  ? 'orange' : 'red'
                      }>
                        {a.subscription_status === 'active' ? '✅ Active' :
                         a.subscription_status === 'trial'  ? '🔄 Trial' : '❌ Expired'}
                      </Badge>
                    </td>
                    <td style={{ fontSize: 12, color: 'var(--text2)' }}>
                      {a.subscription_end_date
                        ? new Date(a.subscription_end_date).toLocaleDateString('en-IN')
                        : '—'}
                    </td>
                    <td>
                      <Badge variant={a.is_active ? 'green' : 'red'}>
                        {a.is_active ? 'Active' : 'Deactive'}
                      </Badge>
                    </td>
                    <td>
                      <button
                        className={`btn btn-sm ${a.is_active ? 'btn-danger' : 'btn-success'}`}
                        onClick={() => toggleStatus(a.id, a.is_active)}
                      >
                        {a.is_active ? '🔴 Deactive' : '🟢 Active'}
                      </button>
                      <button  className="btn btn-ghost btn-sm"
                          onClick={() => openEdit(a)}
                        >
                      ✏️ Edit
                    </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Add Modal */}
      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="👤 New Admin Banao"
        size="md"
      >
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Admin Name *</label>
            <input className="form-input" placeholder="Owner ka naam" value={form.name} onChange={e => f('name', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Shop Name *</label>
            <input className="form-input" placeholder="Shop ka naam" value={form.shop_name} onChange={e => f('shop_name', e.target.value)} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Email *</label>
            <input className="form-input" type="email" placeholder="login email" value={form.email} onChange={e => f('email', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Password *</label>
            <input className="form-input" type="password" placeholder="login password" value={form.password} onChange={e => f('password', e.target.value)} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input className="form-input" placeholder="10-digit" value={form.phone} onChange={e => f('phone', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">WhatsApp</label>
            <input className="form-input" placeholder="WhatsApp number" value={form.whatsapp} onChange={e => f('whatsapp', e.target.value)} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">City</label>
            <input className="form-input" placeholder="Shehar" value={form.city} onChange={e => f('city', e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Address</label>
            <input className="form-input" placeholder="Address" value={form.address} onChange={e => f('address', e.target.value)} />
          </div>
        </div>
        <div className="modal-footer">
          <Button variant="ghost" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button onClick={handleSave} loading={saving}>💾 Admin Banao</Button>
        </div>
      </Modal>
      {/* Edit Modal */}
<Modal
  isOpen={editModal}
  onClose={() => setEditModal(false)}
  title="✏️ Admin Edit Karo"
  size="md"
>
  <div className="form-row">
    <div className="form-group">
      <label className="form-label">Admin Name *</label>
      <input className="form-input" value={editForm.name||''} 
        onChange={e => setEditForm({...editForm, name: e.target.value})} />
    </div>
    <div className="form-group">
      <label className="form-label">Shop Name *</label>
      <input className="form-input" value={editForm.shop_name||''} 
        onChange={e => setEditForm({...editForm, shop_name: e.target.value})} />
    </div>
  </div>
  <div className="form-row">
    <div className="form-group">
      <label className="form-label">Email</label>
      <input className="form-input" type="email" value={editForm.email||''} 
        onChange={e => setEditForm({...editForm, email: e.target.value})} />
    </div>
    <div className="form-group">
      <label className="form-label">Phone</label>
      <input className="form-input" value={editForm.phone||''} 
        onChange={e => setEditForm({...editForm, phone: e.target.value})} />
    </div>
  </div>
  <div className="form-row">
    <div className="form-group">
      <label className="form-label">WhatsApp</label>
      <input className="form-input" value={editForm.whatsapp||''} 
        onChange={e => setEditForm({...editForm, whatsapp: e.target.value})} />
    </div>
    <div className="form-group">
      <label className="form-label">City</label>
      <input className="form-input" value={editForm.city||''} 
        onChange={e => setEditForm({...editForm, city: e.target.value})} />
    </div>
  </div>
  <div className="form-group">
    <label className="form-label">Address</label>
    <input className="form-input" value={editForm.address||''} 
      onChange={e => setEditForm({...editForm, address: e.target.value})} />
  </div>
  <div className="form-group">
    <label className="form-label">New Password (optional)</label>
    <input className="form-input" type="password" 
      placeholder="Khali chhodo agar change nahi karna"
      value={editForm.password||''} 
      onChange={e => setEditForm({...editForm, password: e.target.value})} />
  </div>
  <div className="modal-footer">
    <Button variant="ghost" onClick={() => setEditModal(false)}>Cancel</Button>
    <Button onClick={handleUpdate} loading={saving}>💾 Update Karo</Button>
  </div>
</Modal>
    </div>
  );
};

export default SuperAdminAdmins;